import styled from 'styled-components'
import Icon from './Icon'
import {useContext, useEffect, useState} from 'react'
import Children from './Children'
import {MenuContext} from "../../context/MenuContext";
import { Box } from '@chakra-ui/react';

function Item({
    item,
    childs,
    orderItems,
    addOrderItem,
    removeOrderItem,
    updateOrderItemChildren,
}) {
    const [folded, setFolded] = useState(true)
    const [orderItemQuantity, setOrderItemQuantity] = useState(0)
    const [childrenQuantity, setChildrenQuantity] = useState(0)
    const {menu} = useContext(MenuContext)

    useEffect(() => {
        if (item.id in orderItems) {
            setOrderItemQuantity(orderItems[item.id].quantity)
        } else {
            setOrderItemQuantity(0)
        }

        setChildrenQuantity(findChildrenQuantity())
    }, [item.id, orderItems])

    const findChildrenQuantity = () => {
        let quantity = 0
        const menuItem = menu.find(element => element.id === item.id)

        if (menuItem.has_childrens) {
            menu.forEach(element => {
                if (element.parent_id === item.id && element.id in orderItems) {
                    quantity += orderItems[element.id]
                }
            })
        }

        return quantity
    }

    const onAdd = () => {
        addOrderItem(item)
    }

    const onRemove = () => {
        removeOrderItem(item)
    }

    const renderAdding = () => {
        return <>
            {orderItemQuantity > 0 && <>
                <Icon type={'minus'} onClick={onRemove}/>
                <Quantity>{orderItemQuantity}</Quantity>
            </>}

            <Icon type={'plus'} onClick={onAdd} />
        </>
    }

    const addChildItem = (childItem, index) => {
        updateOrderItemChildren(item, childItem, index)
    }

    const removeChildItem = (childItem, index) => {
        updateOrderItemChildren(item, childItem, index, 'remove')
    }

    const renderChildren = (index) => {
        return <Childs>
            {
                childs.map(childItem => <Children
                    item={childItem}
                    parentItem={item}
                    key={childItem.id}
                    index={index}
                    orderItems={orderItems}
                    addOrderItem={addChildItem}
                    removeOrderItem={removeChildItem}
                />)
            }
        </Childs>
    }

    const renderSelectableItems = orderItems[item.id] && childs.length > 0

    return (
        <Wrapper
            selected={orderItemQuantity > 0 || childrenQuantity > 0}
            unfolded={!folded || childrenQuantity > 0}
            error={orderItems[item.id] && orderItems[item.id].error ? true : false}
        >
            <div>
                <Left>
                    <div>{item.title} <span>{item.price}€</span></div>
                    <p>{item.description}</p>
                </Left>
                <Right>
                    {renderAdding()}
                </Right>
            </div>
            {renderSelectableItems && [...Array(orderItems[item.id].quantity)].map((_, index) => {
                return (<Box key={`sub-item-${index}`} display="block !important" px={4} py={1} borderWidth={1} borderColor="#3F4041" bg="#F4F4F4" borderRadius={10} mb={2} mt={4}>
                    {renderChildren(index)}
                </Box>)
            })
            }
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #F4F4F4;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #F4F4F4;
    border-color: ${props => props.selected && '#AE996F'};
    // background-color: ${props => props.unfolded ? '#E8E8E8' : '#F4F4F4'};

    ${props => props.selected && `
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.19);
        background-color: #E8E8E8;
    `}

    ${props => props.error && `
        border: 3px solid #FF0000;
    `}

    & > div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`;

const Left = styled.div`
    div {
        font-size: 15px;
        margin-bottom: 4px;

        span {
            font-size: 12px;
            color: #AE996F;
        }
    }

    p {
        margin: 0;
        font-size: 11px;
        opacity: 0.7;
    }
`
const Right = styled.div`
    display: flex;
    align-items: center;
    justify-content: right;
    flex-basis: 90px;
    flex-shrink: 0;
    flex-grow: 0;
`

const Quantity = styled.div`
    font-size: 18px;
    margin: 0 5px;
`

const Childs = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;

    & > div:last-child {
        margin-bottom: 0;
    }
`

export {Left, Right, Quantity}

export default Item;
